// import { createUseStyles } from "react-jss";
import { PlaygroundTheme } from '../../Theme';

export const vivaraMessageStyle = (theme: PlaygroundTheme) => ({
  fontSize: 16,
  lineHeight: '22px',
  fontWeight: 400,
  padding: '12px 16px',
  borderRadius: 8,
  backgroundColor: '#F5F5F5',
  boxShadow: 'none',
  '& .menuButton': {
    '& svg': {
      height: '16px !important',
      width: '16px !important',
    },
  },
  '&.is-user-message': {
    backgroundColor: theme.themeLighterAlt,
    color: theme.neutralPrimary,
  },
  '& .ui-chat__messageheader': {
    display: 'none',
  },
});
